import React from 'react'

const G2ColorIcon = React.memo((props: { className?: string }) => (
    <svg
        width="50"
        height="50"
        viewBox="0 0 50 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={props.className}
    >
        <g clip-path="url(#clip0_1_13)">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M50 25C50 38.807 38.807 50 25 50C11.193 50 0 38.807 0 25C0 11.193 11.193 0 25 0C38.807 0 50 11.193 50 25Z"
                fill="#FF492C"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M35.8349 19.1462H31.5624C31.6784 18.4766 32.0914 18.1031 32.9307 17.6781L33.718 17.2788C35.125 16.5579 35.8736 15.7465 35.8736 14.4199C35.8736 13.5828 35.551 12.9258 34.9055 12.4496C34.2731 11.973 33.4985 11.741 32.6078 11.741C31.8979 11.741 31.2524 11.9214 30.6587 12.2948C30.0779 12.6556 29.6389 13.1192 29.368 13.6986L30.6073 14.9351C31.0847 13.9692 31.7818 13.4926 32.6982 13.4926C33.4728 13.4926 33.9505 13.892 33.9505 14.4455C33.9505 14.9094 33.718 15.2955 32.8273 15.7465L32.3239 15.9911C31.2268 16.5449 30.4652 17.1759 30.0262 17.8971C29.5875 18.6054 29.368 19.5196 29.368 20.6146V20.9108H35.8349V19.1462Z"
                fill="white"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M35.2541 22.9554H28.1907L24.6592 29.0736H31.7226L35.2541 35.1921L38.7856 29.0736L35.2541 22.9554Z"
                fill="white"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M25.2576 33.1608C20.7546 33.1608 17.0912 29.5 17.0912 25C17.0912 20.5004 20.7546 16.8395 25.2576 16.8395L28.0533 10.9926C27.1493 10.8133 26.2146 10.7187 25.2576 10.7187C17.3649 10.7187 10.9665 17.1128 10.9665 25C10.9665 32.8876 17.3649 39.2813 25.2576 39.2813C28.4044 39.2813 31.3132 38.2643 33.6741 36.5421L30.5779 31.1834C29.1477 32.4141 27.2887 33.1608 25.2576 33.1608Z"
                fill="white"
            />
        </g>
        <defs>
            <clipPath id="clip0_1_13">
                <rect width="50" height="50" fill="white" />
            </clipPath>
        </defs>
    </svg>
))

export default G2ColorIcon
